import type { CoreState } from '@/core/store/types'

export const SET_ACTIVE_BRAND = (state: CoreState, brandId: string): void => {
  state.activeBrand = brandId
}
